export enum RefundStatus {
    NUEVO = 'Nuevo',
    TRAMITE_INGRESO = 'Trámite de ingreso',
    DEVUELTO = 'Devuelto',
    ENVIADO = 'Enviado',
    FINALIZADO = 'Finalizado',
  }